import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { get } from 'lodash-es';
// Utils
import { getUrgencyMessage, getAskForPriceCopy } from 'site-modules/shared/utils/inventory-utils/get-urgency-message';
import { formatPriceString } from 'site-modules/shared/utils/price-utils';

import './price-summary-pill.scss';

const ICON_CONFIG = {
  icon: 'icon-stats_growth21',
  iconClasses: 'p-0_25 rounded-circle text-white bg-success',
  iconStyle: {
    transform: 'scaleY(-1)',
    fontSize: '1.25rem',
    position: 'absolute',
  },
};

export function PriceSummaryPill({
  originalPrice = 0,
  daysToSell = null,
  isCarMaxDealer = false,
  isEchoParkAutomotiveDealer = false,
  isHerbChambersDealer = false,
}) {
  const askForPriceCopy = getAskForPriceCopy(isCarMaxDealer || isEchoParkAutomotiveDealer || isHerbChambersDealer);
  const urgencyMsg = getUrgencyMessage(daysToSell, askForPriceCopy);
  const text = 'Price Drop:';

  return (
    <div className="d-flex justify-content-center align-items-baseline mt-1_25">
      <div
        className={classnames(
          'price-summary-pill text-gray-darker bg-cool-gray-100 medium px-1 py-0_5 px-md-0_5 px-xl-1 py-xl-0_5 d-flex align-items-center',
          { 'py-md-0_25': !!urgencyMsg, 'py-md-0_5': !urgencyMsg }
        )}
      >
        <i
          className={classnames(get(ICON_CONFIG, 'icon'), get(ICON_CONFIG, 'iconClasses'))}
          style={get(ICON_CONFIG, 'iconStyle')}
        />
        <div className="pill-text" style={{ marginLeft: '36px' }}>
          <div className="fw-bold">
            {text} {<s>{formatPriceString(originalPrice)}</s>}
          </div>
          <div className="">{urgencyMsg}</div>
        </div>
      </div>
    </div>
  );
}

PriceSummaryPill.propTypes = {
  originalPrice: PropTypes.number,
  daysToSell: PropTypes.number,
  isCarMaxDealer: PropTypes.bool,
  isEchoParkAutomotiveDealer: PropTypes.bool,
  isHerbChambersDealer: PropTypes.bool,
};
